import { ZodType } from 'zod'

export default function parseModel<T>(parser: ZodType<T, any, any>, dummyCreator: (uuid: string, error?: any) => T) {
  const parse = (input: any) => {
    const result = parser.safeParse(input)
    if (!result.success) {
      console.log(JSON.stringify(result.error, null, 2))
    }
    return result.success ? result.data : dummyCreator(input?.uuid || 'empty', result.error)
  }

  parse.array = (input: any[]) => input.map(parse)

  return parse
}
